// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"c8139a57","170":"d0c7a2f6","401":"a0d1dfbc"}[chunkId] + ".chunk.css";
};